/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ConfirmationModal, SuccessModal } from '../index';
import { useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { Box, Typography } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';

export const UnlockEmpModal = (props) => {
  const [unlockSuccessOpen, setUnlockSuccessOpen] = useState(false);

  // UNARCHIVE EMPLOYEE RECORD HANDLER
  const handleUnlock = () => {
    fetch(apiUrl('/employee/unlock/' + props.selectedEmp), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setUnlockSuccessOpen(true);
        } else {
          alert(data.message);
        }
      });
  };
  return (
    <>
      <ConfirmationModal
        open={props.open}
        onClose={props.onClose}
        primaryClickHandler={() => {
          handleUnlock();
          props.onClose();
        }}
        secondaryClickHandler={props.onClose}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <LockOpenIcon sx={{ fontSize: 30 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: '#20c997' }}>
              Unlock Employee
            </Typography>
          </Box>
        }
        desc={
          <Box>
            <Typography variant="body1" sx={{ mt: 3, mb: 2 }}>
              Are you sure you want to unlock:
            </Typography>
            <Typography
              variant="h6"
              fontWeight={700}
              color="#20c997 "
              sx={{ mb: 5 }}
            >
              {props.unlockName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This action will give the employee access to the EPS.
            </Typography>
          </Box>
        }
        primaryBtnName={'Unlock'}
        secondaryBtnName={'Cancel'}
        primaryStyle={{
          bgcolor: '#20c997',
          border: '1px solid #20c997',
          '&:hover': {
            bgcolor: '#17b48c !important',
            borderColor: '#17b48c',
          },
        }}
      />
      <SuccessModal
        open={unlockSuccessOpen}
        onClose={() => {
          setUnlockSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        close={() => {
          setUnlockSuccessOpen(false);
          props.resetIndex();
          window.location.reload();
        }}
        desc={'You have successfully unlocked an employee.'}
      />
    </>
  );
};
